import { styled } from 'stitches.config'

export const SkinCoatBenefitsRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  padding: '64px 0px',

  '@bp2': {
    padding: '77px 0px',
  },

  '& span': {
    display: 'inline'
  }
})

export const SkinCoatBenefitsContainer = styled('div', {})
